@let client = client$ | async;

<div id="navbar" [ngClass]="{isScrolled}">
    <img src="/assets/icons/svet-icon.svg" alt="smart-video-enhanced-translation icon" routerLink="/">
    @if(client === null) {
    <div id="navbar-actions">
        <button (click)="loginService.navToGoogleAuth()">{{'auth.login' | translate }}</button>
        <button (click)="loginService.navToGoogleAuth()" class="fill">{{'auth.register' | translate }}</button>
    </div>
    } @else {
    <div id="navbar-actions">
        <button routerLink="/dashboard">dashboard</button>
        <button class="danger" (click)="loginService.logout()">{{'auth.logout' | translate }}</button>
    </div>
    }
</div>